import React from 'react';

const Footer: React.FC = () => {
  return <div className="bg-dark-blue min-h-[10rem] mt-16 shrink-0"></div>;
}

export default Footer;
